import {
	Link, useHistory, useLocation, useParams
} from 'react-router-dom';
import { Form, FormField } from '../../../components/Form/Form';
import { CharlesTitle } from '@abm-international/react-components';
import { useEffect, useMemo, useState } from 'react';
import api from '../../../libraries/api';
import './SinglePOM.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

export const SinglePOM = () => {
	const [ pom, setPom ] = useState<any>();
	const [ loading, setLoading ] = useState(true);
	const [ submitting, setSubmitting ] = useState(false);
	const history = useHistory();

	const { pomId } = useParams<{pomId: string}>();
	const { search } = useLocation();

	const { id } = useMemo(() => {
		const qparams: { [ index: string ]: unknown } = {};
		search?.replace('?', '').split('&').forEach(p => {
			const [name, value] = p.split('=');
			qparams[name] = value;
		});
		return qparams;
	}, [search]);

	useEffect(() => {
		(async () => {
			setLoading(true);

			const _pom = await api.getPom(pomId);
			setPom({
				..._pom,
				pmt_inh: [
					...JSON.parse(_pom.pmt_inh),
					{
						caption: 'Omschrijving',
						id: 'omschrijving',
						name: 'omschrijving',
						type: 'text',
						validation: {
							required: 'required'
						},
						value: _pom.pmi_oms
					}
				],
			});

			if (id) {
				const _filledPom = await api.getPomFilled(id);
				const dataRaw = JSON.parse(_filledPom.pmi_inh);
				const data = dataRaw.map((d: any) => ({
					[d.name]: d.value || d.data,
				}));
				setPom((p: any) => ({
					...p,
					pmt_inh: [
						...dataRaw,
						...[dataRaw.find((d: any) => d.name === 'omschrijving') ? {} : {
							caption: 'Omschrijving',
							id: 'omschrijving',
							name: 'omschrijving',
							type: 'text',
							validation: {
								required: 'required'
							},
							value: _filledPom.pmi_oms
						}]
					],
				}));
			}

			setLoading(false);
		})();
	}, [pomId, id]);

	useEffect(() => {
		if (id) {
			(async () => {
				const _filledPom = await api.getPomFilled(id);
				const dataRaw = JSON.parse(_filledPom.pmi_inh);
				const data = dataRaw.map((d: any) => ({
					[d.name]: d.value || d.data,
				}));

			})();
		}
	}, [pomId]);

	const title = useMemo(() => pom?.pmt_tit, [pom]);

	const submitPOM = async (values: any) => {
		setSubmitting(true);

		try {
			const dataToSubmit = pom.pmt_inh.map((field: any) => {
				const fieldWithValue = { ...field };
				if (field.type !== 'p' && field.name) {
					fieldWithValue[field.type === 'table' ? 'data' : 'value'] = values[field.name];
				}

				return fieldWithValue;
			});


			const data = {
				pmi_tmplid: pom.pmt_tmplid,
				pmi_uti: 1,
				pmi_rei: 'COMOCAT-ID',
				pmi_dtc: new Date(),
				pmi_tit: pom.pmt_tit,
				pmi_inh: dataToSubmit,
				pmi_arc: 'N',
				pmi_oms: dataToSubmit.find(item => item.name === 'omschrijving')?.value || '',
				pmi_mai: pom.pmt_mai?.split(';') || undefined
			};
			const newData = await api.submitPom(JSON.stringify(data));
			toast.success('POM succesvol verzonden!');
			history.push('/pom');
		} catch (error:any) {
			toast.error('Er is een fout opgetreden bij het verzenden van de POM.', error);
		}
	};

	const cancelPOM = () => {
		history.push('/pom');
	};

	if (!pom) return <span>Loading</span>;

	return (
		<div >
			<h1 className={'CharlesTitle'} style={{
				backgroundColor: '#F4F4F4', padding: '1.5rem 4rem', borderRadius: '1rem', width: '100%'
			}}>
				<Link className='backlink' to='/pom' style={{ fontSize: '1.2rem', color: '#6C757D' }}>
					<FontAwesomeIcon icon={faAngleLeft} /> Terug naar POM's
				</Link>
				<span>
					{pom?.pmt_tit || ''}</span>
			</h1>
			{/* <CharlesTitle alt ><span>
				<Link className='backlink' to='/pom'>
					<FontAwesomeIcon icon={faAngleLeft} />
				</Link>
				{pom?.pmt_tit || ''}</span>
			</CharlesTitle> */}

			{!!pom && !loading &&
            <div className='single'>
            	<Form
                	fields={loading ? [] : pom.pmt_inh}
                	onSubmit={submitPOM}
                	onCancel={cancelPOM}
            	/>
            </div>

			}
		</div>
	);
};
